import { render, staticRenderFns } from "./FaqTab.vue?vue&type=template&id=0801c94a&scoped=true&"
import script from "./FaqTab.vue?vue&type=script&lang=ts&"
export * from "./FaqTab.vue?vue&type=script&lang=ts&"
import style0 from "./FaqTab.vue?vue&type=style&index=0&id=0801c94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801c94a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanels,VProgressCircular})
